// extracted by mini-css-extract-plugin
export default {"layout":"xZhg7aLr","header":"OyF50FNM","eyebrow":"TUGhn8B9","title":"PiJGLDw3","grid":"qbreAoIe","tile":"vx9aW6Nq"};